<template>
  <tunnl-modal :value="value" @close="closeModal">
    <v-card class="projects-card">
      <v-card-title class="card-title bg-action text-white">
        {{ projectInfo.name }}
        <v-spacer />
        <v-btn variant="text" rounded="circle" icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list-item v-for="(p, index) in projects" :key="index">
          <v-list-item-title>{{ p.header }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-icon v-show="p.text">mdi-circle-small</v-icon>
            <a
              v-if="type === 'tableau'"
              :class="pendoClass"
              @click="openDashboard(p)">
              {{ p.text }}
            </a>
            <router-link
              v-else
              :to="{
                name: p.route,
                params: p.params,
              }">
              {{ p.text }}
            </router-link>
          </v-list-item-subtitle>
        </v-list-item>
      </v-card-text>
    </v-card>
    <loader :show="tableauStore.loading.trustedUrl" />
    <error-dialog
      v-if="error"
      :message="error"
      @dismiss-error="error = undefined" />
  </tunnl-modal>
</template>

<script>
import TunnlModal from "@/components/TunnlModal.vue";
import { allDashboards } from "@/helpers/getDashboardsAndProjects";
import { mapStores } from "pinia";
import { useTableauStore } from "@/stores/TableauStore";
import { useUserActivityStore } from "@/stores/UserActivityStore";
import ErrorDialog from "@/components/ErrorDialog.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "ProjectsModal",
  components: { TunnlModal, ErrorDialog, Loader },
  props: {
    value: { type: Boolean, required: true },
    name: { type: String, required: true },
    type: { type: String, required: true },
  },
  emits: ["close"],
  data: () => ({
    ranker: {
      name: "Cable Ranker",
      regex: /^TV Ranker$/,
      route: "ranker",
    },
    paid_media: {
      name: "Paid Media",
    },
    earned_media: {
      name: "Earned Media",
    },
    linear_optimization: {
      name: "Linear Optimization",
    },
    booking_optimization: {
      name: "Booking Optimizer",
    },
    error: undefined,
  }),
  computed: {
    ...mapStores(useTableauStore, useUserActivityStore),
    projectInfo() {
      return this[this.name];
    },
    projects() {
      return allDashboards(this.name);
    },
    pendoClass() {
      if (this.type !== "tableau") return "";

      const classMap = {
        linear_optimization: "pendo-linear-opt-dashboard",
        booking_optimization: "pendo-booking-opt-dashboard",
        paid_media: "pendo-paid-media-dashboard",
        earned_media: "pendo-earned-media-dashboard",
      };

      return classMap[this.name] || "";
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async openDashboard(dashboard) {
      this.userActivityStore.create({
        event: "dashboard view",
        meta_data: {
          dashboard_name: dashboard.text,
          dashboard_url: dashboard.url,
          tableau_username: dashboard.username,
        },
      });
      const { data, error } = await this.tableauStore.getTrustedUrl(
        dashboard.id,
      );
      if (data?.url) {
        window.open(data.url);
      } else {
        this.error = error.message;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.projects-card {
  border-radius: 17px !important;

  .v-card-text {
    padding: 5px 15px 15px !important;
  }

  .v-list-item-title {
    color: rgb(var(--v-theme-prominent));
    font-weight: bold;
    font-family: Barlow-Bold, sans-serif;
    font-size: 18px;
    cursor: auto;
  }

  .v-list-item-subtitle {
    i {
      margin-top: -2px;
    }
    a {
      font-size: 16px;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        color: rgb(var(--v-theme-action));
      }
    }
  }
}
</style>
